import {HiShieldCheck} from "react-icons/hi";
import Button from "../Button";
import {useContext} from "react";
import UserAuthenticationContext from "../../tools/contexts/authenticatonService/UserAuthenticationContext";
import {TbForbid} from "react-icons/tb";
import {MdOutlinePending} from "react-icons/md";

const ReportedCard = ({title = "بررسی هویت با موفقیت انجام شد", status, message}) => {
    const userAuthenticationContext = useContext(UserAuthenticationContext);
    const buttonTheme = status === "success" ? "green" : status === "pending" ? "light":"red"
    const icon=status==="success"? <HiShieldCheck className="text-5xl mb-4 text-green-500"/> : status==="pending" ? <MdOutlinePending className="text-5xl mb-4 text-blue-500"/> :<TbForbid className="text-5xl mb-4 text-red-500"/>
    const handleRedirect = () => {
        const price = userAuthenticationContext?.process?.payment?.info ? userAuthenticationContext.process.payment.info.init_amount : 0
        return userAuthenticationContext.handleRedirectToDivar({
            price,
            status: status ? status : ''
        })
    }
    return <div className="flex flex-col items-center justify-center ">
        <div className="flex justify-center mt-10">
            <h1 className="text-3xl text-gray-600  ">
                ونیفای
            </h1>
        </div>
        <div
            className="p-3 mt-5  mx-2 flex w-11/12 md:w-6/12 lg:w-4/12 bg-white rounded-xl  flex-col items-center justify-center">
            {icon}
            <h1 className="font-bold mb-2 text-center">{title}</h1>
            <p className=" text-sm  text-center  ">{message}</p>
            <div className="border-t w-full mt-3  pt-3">

                <Button theme={buttonTheme} className="text-sm  w-full   " rounded="rounded-xl"
                        onClick={handleRedirect}>بازگشت
                    به دیوار </Button>
            </div>
        </div>
    </div>
}
export default ReportedCard;